import { useTranslation } from 'react-i18next';

// Import types
import { DefaultFieldType, FormFieldProps } from 'types/views/form';

// Import styles
import { Label, InputHidden, CheckboxStyled, Content } from './styles';

// Import icons
import { ReactComponent as IconCheck } from 'assets/icons/ic_tick.svg';

// Import utilities
import { useHookFormField } from 'components/utilities';

type Props = FormFieldProps<DefaultFieldType>;

export const Checkbox = (props: Props) => {
	const { t } = useTranslation();
	const { field, isError, isDisabled } = useHookFormField(props);

	return (
		<Label disabled={isDisabled}>
			<InputHidden
				type="checkbox"
				ref={field.ref}
				name={field.name}
				checked={field.value}
				value={field.value}
				disabled={isDisabled}
				onChange={field.onChange}
				onBlur={field.onBlur}
			/>
			<CheckboxStyled checked={field.value} isError={isError}>
				{field.value && <IconCheck />}
			</CheckboxStyled>

			<Content required={props.required}>{t(props.label)}</Content>
		</Label>
	);
};
